// extracted by mini-css-extract-plugin
export default {"fieldAmount":"styles_fieldAmount__ogPnO","contentSubmit":"styles_contentSubmit__Je+Ik"};